import React from 'react'

import { ContentfulSizeChartSection } from '@src/quince-site-common/src/domains/contentful/ContentfulProduct'

import ToggleText from '../../toggleText'

interface SizeChartUnitsToggleProps {
  sizeChartSections: ContentfulSizeChartSection[]
  activeUnitIndex: number
  onUnitsToggle: (index: number, selectedValue: string) => void
}

const UnitsToggleV2 = (props: SizeChartUnitsToggleProps) => {
  const options = props.sizeChartSections.map(section => section.title)
  return (
    <div>
      <ToggleText options={options} activeIndex={props.activeUnitIndex} onChange={props.onUnitsToggle} />
    </div>
  )
}

export default UnitsToggleV2
